import CryptoJS from "crypto-js"

function getCanvasFingerprint() {
  const canvas = document.createElement("canvas")
  canvas.width = 200
  canvas.height = 200
  const ctx = canvas.getContext("2d")
  ctx.fillStyle = "#f60"
  ctx.fillRect(50, 50, 100, 50)
  return canvas.toDataURL()
}
export async function getBrowserFinger() {
  const navigatorInfo = window.navigator
  const screenInfo = window.screen
  let fingerprint = navigatorInfo.userAgent || "" // User Agent
  fingerprint += navigatorInfo.language || "" // Browser language
  fingerprint += screenInfo.colorDepth || "" // Color depth
  fingerprint += screenInfo.pixelDepth || "" // Pixel depth
  // fingerprint += navigatorInfo.platform || "" // Platform
  // fingerprint += navigatorInfo.vendor || "" // Vendor
  fingerprint += navigatorInfo.hardwareConcurrency || "" // Number of logical processors available
  fingerprint += screenInfo.availWidth || "" // Available screen width
  fingerprint += screenInfo.availHeight || "" // Available screen height
  fingerprint += new Date().getTimezoneOffset() || "" // Timezone offset in minutes
  fingerprint += navigatorInfo.cookieEnabled || "" // Cookie enabled?
  fingerprint += getCanvasFingerprint() || "" // Canvas fingerprint
  // fingerprint += navigatorInfo.plugins.length || "" // Number of plugins
  fingerprint += navigatorInfo.doNotTrack || "" // Do Not Track setting
  // fingerprint += navigator.deviceMemory // Device memory
  // fingerprint += navigator.mimeTypes.length // Number of MIME types

  const hash = CryptoJS.SHA256(fingerprint)
  return hash.toString(CryptoJS.enc.Hex)
}
